import { PATIENT_ROLE_ID, ADMIN_ROLE_ID, ADMIN_RESTRICTED_ROLE_ID, PROFESSIONAL_ROLE_ID } from '@/constants/roles'
import { HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION } from '@/constants/healthyCommunitySections'

const forumStore = {
	namespaced: true,
	state: {
		userBasicInfo: {
			userAspId: null,
			nick: '',
			entriesSaved: [],
			messagesSaved: [],
			entriesLike: [],
			messagesLike: [],
			roleId: null,
			companyCode: null,
			pushNotificationsSectionId: [],
			firstAccess: null,
			companiesAccessRestricted: false
		},
		articleData: [],
		entriesCreatedByUser: [],
		entryMessagesCreatedByUser: [],
		numEntries: null,
		messages: [],
		showMoreIds: [],
		showLessIds: [],
		messagesPageNumber: [],
		messagesPerPage: 20,
		entriesPageNumber: 0,
		entriesPerPage: 15,
		showMainPage: true,
		entrySearchValue: null,
		searchSort: 0,
		searchType: null,
		searchId: null,
		showingSearch: false,
		hideOutsideSearchBar: false,
		showMainAnswerBlock: false,
		editingEntry: false,
		sectionId: null,
		hideSearcher: false,
		pushNotifications: [],
		showPushNotificationsModal: false,
		numberPushNotifications: 0,
		entryEditData: null,
		activityFilters: {},
		activityFilterSelected: null
	},
	mutations: {
		toggleCreateNewPost (state, data) {
			state.entryEditData = data || null
		},
		resetMessagesValues (state) {
			state.showMoreIds = []
			state.showLessIds = []
		},
		setActivityFilters (state, filters) {
			state.activityFilters = filters
		},
		setActivityFilterSelected (state, value) {
			state.activityFilterSelected = value
		}
	},
	getters: {
		forumUserIsProfessionalRole: state => {
			return state.userBasicInfo.roleId === PROFESSIONAL_ROLE_ID
		},	  
		forumUserIsPatientRole: state => {
			return state.userBasicInfo.roleId === PATIENT_ROLE_ID
		},
		forumMessageWithoutValidation: (state, getters) => {
			return !getters.forumUserIsPatientRole || state.userBasicInfo.companyCode
		},
		forumEntryWithoutValidation: (state, getters) => {
			return !getters.forumUserIsPatientRole || (state.userBasicInfo.companyCode && state.sectionId == HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION)
		},
		forumUserIsAdminRole: state => {
			return state.userBasicInfo.roleId === ADMIN_ROLE_ID
		},
		forumUserIsAdminRestrictedRole: state => {
			return state.userBasicInfo.roleId === ADMIN_RESTRICTED_ROLE_ID
		}
	}
}

export default forumStore


// WEBPACK FOOTER //
// ./src/store/modules/forum.js